import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {Link} from "gatsby";

import { PageLinks } from "../../common/page-links";
import "./SellProperty.scss";

const PropertyBtn = () => {
    return (
        <React.Fragment>
            <section className="sell-property-banner">
                <Container>
                    <Row>
                        <Col>
                            <div className="sell-wrap">
                                <div className="h4">Do you need to Sell your property first?
                                    <Link to={`/${PageLinks.request_valuation}/`} className="sm-text"> Request a valuation </Link>
                                </div>
                                <i className="icon-home"></i>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default PropertyBtn;
